import classes from "./Field.module.css";

export default function Field(props) {
  const cls = [classes.Field];
  if (props.error) {
    cls.push(classes.Error);
  }

  if (props.type === "select") {
    return (
      <div className={classes.Container}>
        <label className={classes.Label}>{props.label}</label>
        <select
          name={props.name}
          onChange={(e) => props.onChange(e)}
          onBlur={(e) => props.onBlur(e)}
          value={props.value}
          className={cls.join(" ")}
        >
          {props.options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    );
  }

  if (props.type === "textarea") {
    return (
      <div className={classes.Container}>
        <label className={classes.Label}>{props.label}</label>
        <textarea
          name={props.name}
          placeholder={props.placeholder}
          onChange={(e) => props.onChange(e)}
          onBlur={(e) => props.onBlur(e)}
          value={props.value}
          className={cls.join(" ")}
        />
      </div>
    );
  }

  return (
    <div className={classes.Container}>
      <label className={classes.Label}>{props.label}</label>
      <input
        type={props.type || "text"}
        name={props.name}
        placeholder={props.placeholder}
        onChange={(e) => props.onChange(e)}
        onBlur={(e) => props.onBlur(e)}
        value={props.value}
        className={cls.join(" ")}
      />
    </div>
  );
}
